<template>
  <div class="table-responsive" v-if="hasProductsInCart">
    <table class="table table-cart table-cart-items bottom-shadow border-6">
      <thead>
      <tr>
        <th>
          Produtos
        </th>
        <th>
          Tipo
        </th>
        <th>
          Período
        </th>
        <th class="col-sm-2">
          Quantidade
        </th>
        <th class="col-sm-2">
          Valor Unitário
        </th>
        <th class="col-sm-1">
          Desconto
        </th>
        <th class="col-sm-2">
          Valor Total
        </th>
        <th ></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="orderProduct in products['supports']">
        <table-item
          product-key="supports"
          :product-type-id="6"
          :order-product="orderProduct"
          product-type="SUPORTE">
        </table-item>
      </template>

      <template v-for="orderProduct in products['papers']">
        <table-item
          product-key="papers"
          :product-type-id="5"
          :order-product="orderProduct"
          product-type="PAPEL">
        </table-item>
      </template>

      <template v-for="orderProduct in products['templates']">
        <table-item
          product-key="templates"
          :product-type-id="4"
          :order-product="orderProduct"
          product-type="CAMPANHA">
        </table-item>
      </template>

      <template v-for="orderProduct in products['licenses']">
        <table-item
          product-key="licenses"
          :product-type-id="1"
          :order-product="orderProduct"
          product-type="LICENÇA">
        </table-item>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import TableItem from './TableItem.vue';

  export default {
    name: 'table-items',

    props: {
      productsProp: Object,
    },

    components: {
      TableItem,
    },

    mounted() {
      this.$on('removeItem', (payload) => {
        this.deleteItem(payload);
      });
      const vm = this;

      this.isAuthenticated = !!window.User;
      if (!this.isAuthenticated) {
        vm.getProductsByLocalStorage();
      } else {
        const vuex = JSON.parse(localStorage.getItem('vuex'));
        if (this.isAuthenticated && vuex) {
          vm.getProductsByLocalStorage();
          this.updateTotal();
          const cart = vuex.cart || [];
          const token = $('meta[name="csrf-token"]').attr('content');
          if (window.canAddToCart) {
            $.post('/ajax/store/cart-local-storage', {
              cart: cart,
              _token: token,
            }).then(() => {
              localStorage.removeItem('vuex');
            }).catch();
          } else {
            localStorage.removeItem('vuex');
          }
        }
      }
      vm.$root.$emit('updateCoupon');

      this.updateTotal();
    },

    computed: {

      hasProductsInCart() {
        if (!this.isAuthenticated)
          return this.cart.length > 0;

        let count = 0;
        const productsKeys = ['licenses', 'templates', 'papers', 'supports'];

        productsKeys.map((key) => count += this.products[key].length);

        return count > 0;
      },

      cart: {
        get() {
          return this.$store.getters['getCart'];
        },
        set(cart) {
          this.$store.commit('SET_CART', cart);
        },
      },
    },

    data: function() {
      return {
        products: this.productsProp || [],
        isAuthenticated: false,
      };
    },

    methods: {
      deleteItem(payload) {
        const index = this.products[payload.key].findIndex((obj) => {
          return obj.id === payload.id;
        });
        if (index !== -1)
          this.products[payload.key].splice(index, 1);
        this.$root.$emit('updateTotals');
      },

      getProductsByLocalStorage() {
        const vm = this;
        const token = $('meta[name="csrf-token"]').attr('content');
        $.post('/ajax/store/products-local-storage', {
          cart: vm.cart,
          productTypeId: vm.productTypeId,
          _token: token,
        }).then((result) => {
          vm.products = result;
        }).catch();
      },

      updateTotal() {
        this.$root.$emit('updateTotals');
      },
    },

  };
</script>

<style scoped>
  table {
    border-collapse: unset;
  }
  table th:first-child{
    border-top-left-radius:6.79px;
    border-left: 1px solid #ED1763 !important;
  }

  table th:last-child{
    border-top-right-radius:6.79px;
    border-right: 1px solid #ED1763 !important;
  }

  .table-cart thead th {
    border-top: 1px solid #ED1763 !important;
    border-bottom: 1px solid #ED1763 !important;
  }


</style>

<style>
  .table-cart-items tr:last-child td:first-child {
    border-bottom-left-radius: 6.79px;
  }

  .table-cart-items tr:last-child td:last-child {
    border-bottom-right-radius: 6.79px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/store/components/TableItems.vue